import React from "react"
import BottomSheet from "../BottomSheet/BottomSheet"
import DisconnectionIcon from "../DisconnectionIcon/DisconnectionIcon"
import { PrimaryButton } from "../PrimaryButton/PrimaryButton"
import CrossIcon from "../CrossIcon/CrossIcon"
import {
    Container,
    CloseButtonContainer,
    CrossButton,
    IconContainer,
    Title,
    Description,
    ButtonContainer
} from "./ErrorBottomSheet.styles"

export type ErrorBottomSheetProps = {
    isOpen: boolean
    title: string
    description: string
    onClose: () => void
    onRetry: () => void
    useContactUs?: boolean
    onContactUs?: () => void
    tryAgainLabel: string
    contactUsLabel: string
}

const ErrorBottomSheet = ({
    isOpen,
    title,
    description,
    onClose,
    onRetry,
    useContactUs = false,
    onContactUs,
    tryAgainLabel,
    contactUsLabel,
}: ErrorBottomSheetProps) => {
    return (
        <BottomSheet
            isOpen={isOpen}
            onClose={onClose}
            showCloseButton={false}
            height='50%'
            header={<React.Fragment />}
        >
            <Container>
                <CloseButtonContainer>
                    <CrossButton onClick={onClose}>
                        <CrossIcon color="black" size={12} thickness={1} />
                    </CrossButton>
                </CloseButtonContainer>
                <IconContainer>
                    <DisconnectionIcon />
                </IconContainer>
                <Title>
                    {title}
                </Title>
                <Description>
                    {description}
                </Description>
                <ButtonContainer>
                    <PrimaryButton
                        onClick={useContactUs && onContactUs ? onContactUs : onRetry}
                        variant="outline-black"
                    >
                        {useContactUs ? contactUsLabel : tryAgainLabel}
                    </PrimaryButton>
                </ButtonContainer>
            </Container>
        </BottomSheet>
    )
}

export default ErrorBottomSheet
